export default {
    'storeOrders.title': 'Store Orders',
    'storeOrders.last_three_months': 'Last Three Months',
    'storeOrders.last_six_months': 'Last Six Months',
    'storeOrders.last_one_year': 'Last One Year',
    'storeOrders.filter_state_category.one': 'Shopping Cart/Checkout',
    'storeOrders.filter_state_category.two': 'Checked Out/Payment',
    'storeOrders.filter_state_category.three': 'Cancelled/Refunded',
    'storeOrders.filter_state_category.four': 'Partially Cancelled/Refunded',
    'storeOrders.order.no': 'Order Number',
    'storeOrders.order.amount': 'Total Amount',
    'storeOrders.order.status': 'Order Status',
    'storeOrders.order.payment_status': 'Payment Status',
    'storeOrders.order.date': 'Order Date',
    'storeOrders.order.cancel_date': 'Order Cancellation Date',
    'storeOrders.order.detail': 'Order Details',
    'storeOrders.search_order.placeholder': 'Enter Your Order Number',
    'storeOrders.empty': 'No Data',
    'storeOrders.carrier.phone': 'Phone Barcode',
    'storeOrders.carrier.member': 'Member Carrier',
    'storeOrders.carrier.company': 'Unified Business Number',
    'storeOrders.order_info': 'Order Information',
    'storeOrders.order_refund_date': 'Order Refund Date',
    'storeOrders.refund_amount': 'Refund Amount',
    'storeOrders.credit_card_last_four_digits': 'Last Four Digits of Credit Card',
    'storeOrders.contact_number': 'Contact Number',
    'storeOrders.email': 'Email',
    'storeOrders.company_header': 'Company Header',
    'storeOrders.order_detail': 'Product Details',
    'storeOrders.order_code': 'Order Barcode',
    'storeOrders.close': 'Close',
    'storeOrders.search_fail': 'Search Failed',
    'storeOrders.text.research': 'You can try clicking the button below to retry your search',
    'storeOrders.retry': 'Retry',
} as Record<string, string>;
